import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjectUtilityService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Observables are part of the RxJS (Reactive Extensions for JavaScript) library, which Angular uses extensively.
   * Observables are lazy, meaning they do not execute until subscribed to. This allows you to manage asynchronous
   * data in a more declarative and functional style.
   *
   * An Observable can emit multiple values over time, and you can subscribe to it to get those values
   */
  getProjectTypeTree(ProjectTypeId): Observable<any> {
    return this.http.post(
      `${this.apiUrl}/project-types/get-parent-hierarchy/${ProjectTypeId}`,
      {}
    );
  }

  formattedProjectTypeTree(data: any[]) {
    console.log(
      'data data data data data data data data data data data data data'
    );
    console.log(data);

    const lastObject = data[data.length - 1];
    const result = [lastObject.name];

    // Insert the parent name at the beginning
    if (lastObject.parent) {
      result.unshift(lastObject.parent.name);
    }
    console.log(result);
    return result;
  }

  getProjectCountry(ProjectCountryId): Observable<any> {
    return this.http.get(`${this.apiUrl}/countries/${ProjectCountryId}`);
  }

  getProjectGrade(ProjectGradeId): Observable<any> {
    return this.http.get(`${this.apiUrl}/grades/${ProjectGradeId}`);
  }
}
